import { X, HardHat, ArrowRight } from "lucide-react";
import ModalOverlay from "../UI/ModalOverlay/ModalOverlay.tsx";
import styles from "./OfferSkillsMismatchModal.module.scss";

interface OfferSkillsMismatchModalProps {
  isOpen: boolean;
  onClose: () => void;
  skillLabels: string[];
  onGoToProfileRubros: () => void;
}

const OfferSkillsMismatchModal: React.FC<OfferSkillsMismatchModalProps> = ({
  isOpen,
  onClose,
  skillLabels,
  onGoToProfileRubros,
}) => {
  if (!isOpen) return null;

  const skillsText =
    skillLabels.length > 0
      ? skillLabels.join(", ")
      : "los rubros de esta búsqueda";

  return (
    <ModalOverlay isOpen={isOpen} onClose={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <header className={styles.header}>
          <h2 className={styles.title}>Agregá un rubro a tu perfil</h2>
          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Cerrar"
          >
            <X size={20} />
          </button>
        </header>
        <div className={styles.body}>
          <p className={styles.subtitle}>
            Esta búsqueda está orientada a perfiles con experiencia en:
          </p>
          <div className={styles.chipGroup}>
            {skillLabels.map((label, index) => (
              <span key={`${label}-${index}`} className={styles.chip}>
                <HardHat size={14} />
                {label}
              </span>
            ))}
          </div>
          <p className={styles.hint}>
            Para postular, andá a <strong>Editar perfil → Mis rubros</strong> y agregá al
            menos uno de estos rubros ({skillsText}).
          </p>
        </div>
        <footer className={styles.footer}>
          <button type="button" className={styles.secondaryButton} onClick={onClose}>
            Volver a la oferta
          </button>
          <button type="button" className={styles.primaryButton} onClick={onGoToProfileRubros}>
            Ir a Mis rubros
            <ArrowRight size={16} />
          </button>
        </footer>
      </div>
    </ModalOverlay>
  );
};

export default OfferSkillsMismatchModal;
